var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Actions, Effect, ofType } from "@ngrx/effects";
import { tap } from "rxjs/operators";
import { LayoutService } from "@app/core/services/layout.service";
import { LayoutActionTypes } from "./layout.actions";
var LayoutEffects = /** @class */ (function () {
    function LayoutEffects(actions$, layoutService) {
        var _this = this;
        this.actions$ = actions$;
        this.layoutService = layoutService;
        this.onSmartSkin$ = this.actions$.pipe(ofType(LayoutActionTypes.SmartSkin), tap(function (action) { return _this.layoutService.onSmartSkin(action.payload); }));
        this.onFixedHeader$ = this.actions$.pipe(ofType(LayoutActionTypes.FixedHeader), tap(function (action) { return _this.layoutService.onFixedHeader; }));
        this.onFixedNavigation$ = this.actions$.pipe(ofType(LayoutActionTypes.FixedNavigation), tap(function (action) { return _this.layoutService.onFixedNavigation; }));
        this.onFixedRibbon$ = this.actions$.pipe(ofType(LayoutActionTypes.FixedRibbon), tap(function (action) { return _this.layoutService.onFixedRibbon; }));
        this.onFixedPageFooter$ = this.actions$.pipe(ofType(LayoutActionTypes.FixedPageFooter), tap(function (action) { return _this.layoutService.onFixedPageFooter; }));
        this.onInsideContainer$ = this.actions$.pipe(ofType(LayoutActionTypes.InsideContainer), tap(function (action) { return _this.layoutService.onInsideContainer; }));
        this.onRtl$ = this.actions$.pipe(ofType(LayoutActionTypes.Rtl), tap(function (action) { return _this.layoutService.onRtl; }));
        this.onMenuOnTop$ = this.actions$.pipe(ofType(LayoutActionTypes.MenuOnTop), tap(function (action) { return _this.layoutService.onMenuOnTop; }));
        this.onColorblindFriendly$ = this.actions$.pipe(ofType(LayoutActionTypes.ColorblindFriendly), tap(function (action) { return _this.layoutService.onColorblindFriendly; }));
        this.onCollapseMenu$ = this.actions$.pipe(ofType(LayoutActionTypes.CollapseMenu), tap(function (action) { return _this.layoutService.onCollapseMenu; }));
        this.onMinifyMenu$ = this.actions$.pipe(ofType(LayoutActionTypes.MinifyMenu), tap(function (action) { return _this.layoutService.onMinifyMenu; }));
        this.onShortcutToggle$ = this.actions$.pipe(ofType(LayoutActionTypes.ShortcutToggle), tap(function (action) { return _this.layoutService.onShortcutToggle; }));
    }
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Object)
    ], LayoutEffects.prototype, "onSmartSkin$", void 0);
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Object)
    ], LayoutEffects.prototype, "onFixedHeader$", void 0);
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Object)
    ], LayoutEffects.prototype, "onFixedNavigation$", void 0);
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Object)
    ], LayoutEffects.prototype, "onFixedRibbon$", void 0);
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Object)
    ], LayoutEffects.prototype, "onFixedPageFooter$", void 0);
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Object)
    ], LayoutEffects.prototype, "onInsideContainer$", void 0);
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Object)
    ], LayoutEffects.prototype, "onRtl$", void 0);
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Object)
    ], LayoutEffects.prototype, "onMenuOnTop$", void 0);
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Object)
    ], LayoutEffects.prototype, "onColorblindFriendly$", void 0);
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Object)
    ], LayoutEffects.prototype, "onCollapseMenu$", void 0);
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Object)
    ], LayoutEffects.prototype, "onMinifyMenu$", void 0);
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Object)
    ], LayoutEffects.prototype, "onShortcutToggle$", void 0);
    return LayoutEffects;
}());
export { LayoutEffects };
